module.exports = __webpack_public_path__ + "img/ico_mais.40e8e39c.svg";